var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInscriptionMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 358"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 0H0v331.24c0 106.76 234.3-150.65 360 0V0z",
    fill: "#078DBE",
    fillOpacity: 0.7
  })));
}

export default __webpack_public_path__ + "e36861c7deeac3118c5daec95d41e2db.svg";
export { SvgInscriptionMobile as ReactComponent };